module.exports = __webpack_public_path__ + "css/Ascot.47c81980.css";